import {
  glyphIconStyle,
  helpbuttonStyle,
  inputFieldStyle,
  searchboxStyle,
  buttonInputStyle,
  uiblockerStyle,
  linkStyle,
  convertToLocalStyle,
  tableStyle,
  paginationStyle,
  truncatedStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { getTableStyles } from '@bingads-webui-campaign-react/grid-view-wrapper';

export const getAssignmentPageStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  assignment: {
    margin: '20px 0px',
    display: 'flex',
    flex: '1 0 1px',
    overflow: 'auto',
    flexDirection: 'column',

    '& .alert': {
      fontSize: 14,
    },

    '& .error': {
      color: palette.redDark,
    },

    '& ul[role=alert]': {
      listStyle: 'none',
      paddingLeft: 0,
    },

    '& .inactive': {
      color: palette.neutralTertiary,
    },

    '& .hotel-groups__container': {
      width: '100%',
      '& .create-button__container': {
        width: 'auto',
      },
      '& .associations-download__container': {
        width: 'auto',
        padding: 0,
        '& input': {
          background: palette.white,
          color: palette.neutralPrimary,
          border: `1px solid ${palette.neutralSecondaryAlt}`,
        },
        '& input.disabled': {
          background: palette.neutralLighter,
          color: palette.neutralTertiary,
          cursor: 'not-allowed',
        },
      },
      '& .subaccount-edit__container': {
        width: 'auto',
        height: 32,
        lineHeight: '32px',
        '& span': {
          padding: '0px 5px',
        },
      },
      '& .hotel-groups-list__container': {
        display: 'none',
      },
      '& .subaccount-hotelgroup-edit-panel-container': {
        marginBottom: 32,
        '& button.is-disabled .edit-menu-icon': {
          color: palette.neutralTertiary,
        },
        '& .edit-menu-icon': {
          margin: '0px 4px',
          top: 0,
          color: palette.themePrimary,
        },
      },
    },

    '& .search-box': {
      '& input': {
        height: 32,
        paddingLeft: 30,
        border: `1px solid ${palette.neutralSecondaryAlt}`,
      },
      '& input:hover': {
        border: `1px solid ${palette.neutralPrimary}`,
        outline: 'none',
      },
      '& input:focus': {
        border: `1px solid ${palette.themePrimary}`,
        outline: 'none',
      },
      '& button': {
        background: 'none',
        border: 'none',
        position: 'absolute',
        left: 21,
        top: 6,
        width: 21,
        height: 21,
        '& .filter_search_icon_small': {
          position: 'relative',
          left: -3,
        },
      },
      '& button:focus': {
        border: `1px solid ${palette.neutralSecondaryAlt}`,
        outline: 'none',
      },
    },

    '& .hotel-group-associations-no-subaccount-container': {
      marginLeft: 15,
    },

    '& .hotel-associations__container': {
      width: 1500,
      marginTop: 30,
      ...tableStyle({ palette }),
      ...getTableStyles(_, { palette }),
      ...paginationStyle({ palette }),
      '& .table-bordered': {
        width: 600,
      },
      '& .group-edit-menu': {
        display: 'none',
      },
      '& .filter-bar': {
        backgroundColor: palette.neutralLighter,
        '& .panel-body': {
          width: 'fit-content',
          height: 'fit-content',
          display: 'flex',
          alignItems: 'center',
        },
        '& .filter_title_collapsed': {
          display: 'none',
        },
        '& .filter_row_readonly': {
          display: 'inline-block',
          backgroundColor: palette.neutralSecondary,
          color: palette.white,
          fontSize: 14,
          lineHeight: '24px',
          padding: '0px 30px 0px 10px',
          maxWidth: 550,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          '& .humanized': {
            margin: '0px 10px',
            '& .filter_operator': {
              margin: '0px 5px',
            },
          },
        },
        '& .filter_links': {
          display: 'inline-block',
          fontSize: 14,
          lineHeight: '24px',
          '& .editFilterLink': {
            display: 'none',
          },
          '& .removeFilterLink': {
            paddingLeft: 8,
          },
          '& a:nth-child(4)': {
            display: 'none',
          },
          '& .remove_icon_gray_16': {
            fontFamily: iconFontFamily,
            color: palette.white,
            cursor: 'pointer',
            marginLeft: -25,
            display: 'inline',
            position: 'absolute',
          },
          '& .remove_icon_gray_16:before': {
            content: '"\\E711"',
          },
        },
      },
      '& .hotel-in-group__container, .hotel-out-group__container': {
        '& .group-information-line__container': {
          padding: 0,
          marginBottom: 10,
          '& .group-information-name': {
            padding: 0,
            fontWeight: 600,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        },
        '& > div > div:nth-child(2) > div.col-sm-12': {
          paddingRight: 0,
        },
        '& .toolbar-container': {
          marginBottom: 10,
        },
        '& input[type="checkbox"]:focus': {
          outline: `1px solid ${palette.neutralSecondary}`,
        },
        '& .pagination-control .page-size-selector:focus': {
          borderColor: palette.themePrimary,
        },
      },
      '& .hotel-in-group__container': {
        '& .status-message__container .status-message': {
          display: 'none',
        },
        '& colgroup': {
          '& col.col-selection': {
            width: 50,
          },
          '& col.col-PartnerHotelId': {
            width: 150,
          },
          '& col.col-Name': {
            width: 250,
          },
          '& col.col-HotelGroupName': {
            width: 150,
          },
        },
      },
      '& .hotel-association-assignment-container': {
        marginTop: 70,
        paddingLeft: 30,
        '& .btn-primary': {
          marginBottom: 20,
        },
        '& .btn-primary.disabled': {
          color: palette.neutralSecondary,
        },
        '& .btn-primary.disabled:focus': {
          color: palette.neutralSecondary,
          borderColor: palette.neutralLighter,
          backgroundColor: palette.neutralLighter,
        },
      },
      '& .hotel-out-group__container': {
        '& colgroup': {
          '& col.col-selection': {
            width: 50,
          },
          '& col.col-PartnerHotelId': {
            width: 150,
          },
          '& col.col-HotelName': {
            width: 200,
          },
          '& col.col-HotelGroupName': {
            width: 100,
          },
          '& col.col-SubAccountName': {
            width: 100,
          },
        },
      },
      '& .bingadsgrid': {
        width: 600,
        '& .table > thead > tr > th': {
          borderBottom: `2px solid ${palette.neutralSecondaryAlt} !important`,
        },
        '& .table > tbody > tr > td': {
          padding: '8px 10px',
        },
        '& thead.header': {
          '& tr th:first-child': {
            paddingLeft: 10,
          },
          '& tr th.column-header span.grid-header-text': {
            wordBreak: 'keep-all',
            overflowWrap: 'unset',
          },
        },
        '& .footer .header-subview-0': {
          paddingTop: 0,
        },
        '& .pagination-control': {
          '& .text': {
            padding: 8,
          },
          '& .page-number-input': {
            marginLeft: 0,
          },
        },

        '& input[type="checkbox"]:focus': {
          outline: `1px solid ${palette.neutralSecondary}`,
          outlineOffset: 1,
        },
      },
    },
    ...convertToLocalStyle(glyphIconStyle({ palette })),
    ...convertToLocalStyle(helpbuttonStyle({ palette })),
    ...convertToLocalStyle(inputFieldStyle({ palette })),
    ...buttonInputStyle({ palette }),
    ...searchboxStyle({ palette }),
    ...linkStyle,
    ...truncatedStyle,
  },
  '@global': {
    '.bingads-campaign-react-sub-page-menu .compared-date-range-picker': {
      display: 'none',
    },
    '.hotel-center-group-dialog': {
      '& .input-control': {
        marginTop: 15,
        marginBottom: 15,
      },
      '& ul[role=alert]': {
        color: palette.redDark,
        listStyle: 'none',
        paddingLeft: 0,
      },
      '& .hotel-center-group-dialog-save.disabled': {
        background: palette.neutralLighter,
        color: palette.neutralTertiary,
      },
      '& .hotel-center-group-dialog-save': {
        background: palette.themePrimary,
        color: palette.white,
      },
      '& .close': {
        fontSize: 28,
      },
    },
    '.hotel-center-associate-attention-dialog': {
      '& .attention-information-dismiss__container': {
        margin: '20px 0px',
      },
      '& .hotel-center-associate-attention-dialog-save': {
        backgroundColor: palette.themePrimary,
        color: palette.white,
      },
      '& .close': {
        fontSize: 28,
      },
    },
    '.ms-Dropdown-callout': {
      '& .ms-SearchBox': {
        borderColor: palette.neutralTertiary,
        margin: 8,
      },
      '& .ms-SearchBox-icon': {
        fontFamily: iconFontFamily,
        fontSize: 14,
        content: '"\\E721"',
      },
      '& .nav-tree-container': {
        '& a.ms-Nav-link': {
          color: palette.neutralPrimary,
          '& > span > span': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        },
        '& .create-new-icon': {
          left: -20,
          color: palette.themePrimary,
        },
        '& #nav-action-create-new': {
          marginLeft: -15,
        },
      },
    },
    ...uiblockerStyle({ palette }),
  },
});
